
if(!__webpack_require__.federation){
    __webpack_require__.federation = {
        
chunkMatcher: function(chunkId) {
    return !/^(5([06]80|336|532)|(812|935|969)4|12|2352|2678|7190)$/.test(chunkId);
},
rootOutputDir: "",

    };
}
